import React from "react";
import {
    PolarAngleAxis,
    PolarGrid,
    Radar,
    RadarChart,
    ResponsiveContainer,
    Tooltip,
} from "recharts";
import styled from "styled-components";
import NoDataPlaceholder from "src/components/no-data-placeholder";
import { Stack } from "@mui/material";

const TooltipContainer = styled.div`
    background-color: ${({ theme }) => theme.palette.background.tooltip};
    padding: 0.5rem;
    min-width: 10rem;
    align-items: center;
    flex-direction: column;
    border-radius: 6px;
`;

const TooltipTitle = styled.p`
    margin-top: 0;
    margin-bottom: 0.5rem;
    color: ${({ color }) => color};
`;

const TooltipContent = styled.p`
    font-size: 12px;
    max-width: 15rem;
    margin: 0;
`;
const formatTitles = (item) => {
    return (item.charAt(0).toUpperCase() + item.slice(1)).replace(/([A-Z])/g, " $1");
};

const CustomTooltip = ({ active, payload }) => {
    const maxEntries = 10;
    let count = 0;
    if (active && payload && payload.length) {
        return (
            <TooltipContainer role="status" aria-live="assertive">
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    style={{ width: "100%" }}
                >
                    <TooltipTitle>{formatTitles(payload[0].payload.subject)}</TooltipTitle>
                    <TooltipTitle>{`${payload[0].payload.value}`}</TooltipTitle>
                </Stack>
                {payload[0].payload.items.map((item) => {
                    if (count < maxEntries) {
                        count += 1;
                        return <TooltipContent key={item}>{`${item}`}</TooltipContent>;
                    }
                    if (count === maxEntries) {
                        count += 1;
                        return (
                            <TooltipContent key={item}>{`+ ${
                                payload[0].payload.items.length - 10
                            } more`}</TooltipContent>
                        );
                    }
                    return null;
                })}
            </TooltipContainer>
        );
    }
    return null;
};

const TemplateSpiderChart = ({ data, parameters }) => {
    if (!data) return <NoDataPlaceholder variant="pie" />;
    return (
        <ResponsiveContainer width="100%" height="100%">
            <RadarChart accessibilityLayer cx="50%" cy="50%" outerRadius="80%" data={data}>
                <PolarGrid opacity={0.2} />
                {parameters.polarValues.map((polarValue) => (
                    <PolarAngleAxis
                        dataKey={polarValue.dataKey}
                        tick={{
                            fill: "#EAF0F4",
                            opacity: "0.6",
                            fontSize: "12px",
                            ...polarValue.tick,
                        }}
                        tickFormatter={formatTitles}
                    />
                ))}
                {parameters.radarValues.map((radarValue) => (
                    <Radar
                        dataKey={radarValue.dataKey}
                        stroke={radarValue.stroke}
                        fill={radarValue.fill}
                        fillOpacity={radarValue.fillOpacity}
                    />
                ))}
                <Tooltip content={CustomTooltip} />
            </RadarChart>
        </ResponsiveContainer>
    );
};

export default TemplateSpiderChart;
